<template>
  <div>
    <el-input type="mail" placeholder="请输入修改密码" v-model="email" />
    <el-button type="primary" @click="loginsubmit()">确 定</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      ret: "",
    };
  },
  methods: {
    loginsubmit() {
      var httpurl = document.location.href;
      this.ret = httpurl.split("=")[1];
      let formData = new FormData();
      formData.append("password", this.email);
      formData.append("param", this.ret);
      this.$axios.defaults.withCredentials = true;
      this.$axios
        .post(this.$getaxiosurl("/resetPwd"), formData)
        .then(function (res) {
          if (res.data.code != "00100") {
            alert(res.data.msg);
          } else {
            alert(res.data.msg);
          }
        });
    },
  },
};
</script>
<style scoped>
</style>
